import { getMemberProfile } from "../../services/apiService"
import { updateObjectState } from "../../utils/updateObjectStates"

export const getMemberType =  async (userAuthState , setUserAuthState) => {
    if(!userAuthState.memberType || userAuthState.memberType === "" ) {
        let memberProfile = await getMemberProfile(userAuthState.rydeSendToken)
        setUserAuthState((prevState)=>{ return updateObjectState('memberType', memberProfile.data.memberType, prevState)})
    }
}